"use client";

import DataLayer from "@/components/data-layer/data-layer";
import React from "react";
import "@/components/forms/hubspot-embed.global.css";

interface HubspotEmbedProps {
  formId: string;
  dataLayerProps: Record<string, any> | null;
  isSubmitted?: boolean;
  targetId?: string;
  className?: string;
}

const HubspotEmbed: React.FC<HubspotEmbedProps> = ({ formId, dataLayerProps, isSubmitted, targetId, className }) => (
  <>
    {/* The HubSpot form will be rendered here */}
    <div
      id={targetId ?? `hubspotForm-${formId}`}
      className={className ?? "hubspotForm"}
      data-testid={targetId ?? `hubspot-form-${formId} `}
      style={{
        display: isSubmitted ? "none" : "auto"
      }}
    />
    {dataLayerProps && <DataLayer data={dataLayerProps} />}
  </>
);

export default HubspotEmbed;
